import { z } from 'zod';

/** An MGA a report can be narrowed to, from `platform.agencies`. */
export const reportFilterAgencyOptionSchema = z.object({
  agencyId: z.string(),
  name: z.string(),
  contactEmail: z.string().nullable(),
});

export type ReportFilterAgencyOptionDto = z.infer<typeof reportFilterAgencyOptionSchema>;

/** An RMD whose agencies a company-wide report can be narrowed to, from `platform.agents`. */
export const reportFilterRmdOptionSchema = z.object({
  agentId: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  fullName: z.string().nullable(),
  email: z.string().nullable(),
});

export type ReportFilterRmdOptionDto = z.infer<typeof reportFilterRmdOptionSchema>;

/**
 * What the "Filter by RMD or MGA" box may offer a viewer in a scope. Company-wide: every MGA and
 * every RMD. An RMD: the MGAs they are the RMD for. An MGA page has nothing to narrow.
 */
export const reportFilterOptionsResponseSchema = z.object({
  agencies: z.array(reportFilterAgencyOptionSchema),
  rmds: z.array(reportFilterRmdOptionSchema),
});

export type ReportFilterOptionsResponseDto = z.infer<typeof reportFilterOptionsResponseSchema>;
